import React from "react";
import { Container, Button } from "./ui";
import { ArrowRightIcon } from "./ui/icons";

// Replaces the old Pricing band, which advertised a one-time fee that no longer
// applies and whose call to action was a div that did nothing.
const GetRankedCta = () => (
  <section className="bg-surface py-16 md:py-20">
    <Container>
      <div className="relative overflow-hidden rounded-lg bg-gradient-to-br from-navy via-[#12234A] to-primary px-6 py-12 md:px-12 md:py-16">
        <svg
          aria-hidden="true"
          className="pointer-events-none absolute -right-12 -top-12 h-72 w-72 text-white/10"
          viewBox="0 0 200 200"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <circle cx="100" cy="100" r="90" />
          <circle cx="100" cy="100" r="60" />
          <path d="M100 10v180M10 100h180" />
        </svg>

        <div className="relative max-w-lg">
          <h2 className="text-2xl font-bold tracking-tight text-white md:text-3xl">
            Ready to join the rankings?
          </h2>
          <p className="mt-3 text-base leading-relaxed text-white/70">
            Create your player profile, compete in tournaments, and climb the
            global rankings.
          </p>
          <div className="mt-7 flex flex-wrap gap-3">
            <Button to="/register" variant="inverse" size="lg">
              Create Player Profile
              <ArrowRightIcon className="h-4 w-4" />
            </Button>
            <Button to="/rankings" variant="inverse-outline" size="lg">
              Explore Rankings
            </Button>
          </div>
        </div>
      </div>
    </Container>
  </section>
);

export default GetRankedCta;
